import { useEffect, useState, Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Index from "./pages/Index";
import Company from "./pages/Company";
import Cases from "./pages/Cases";
import Services from "./pages/Services";
import Careers from "./pages/Careers";
import ServiceDDT from "./pages/ServiceDDT";
import ServiceOutsource from "./pages/ServiceOutsource";
import ServiceOutstaff from "./pages/ServiceOutstaff";

import Cookies from "./components/Cookies/Cookies";
import Preloader from "./components/Preloader/Preloader";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CheckAuth from "./utils/CheckAuth";
import CheckRoles from "./utils/CheckRoles";

import AdminReg from "./pages/AdminPanel/AdminReg";

const CaseJoinuz = lazy(() => import("./pages/CaseJoinuz"));
const CaseStartup = lazy(() => import("./pages/CaseStartup"));
const CaseAquaPal = lazy(() => import("./pages/CaseAquaPal"));
const CaseJoyn = lazy(() => import("./pages/CaseJoyn"));
const CaseSaqure = lazy(() => import("./pages/CaseSaqure"));
const CaseZise = lazy(() => import("./pages/CaseZise"));
const CaseZiksen = lazy(() => import("./pages/CaseZiksen"));
const CaseRainbow = lazy(() => import("./pages/CaseRainbow"));
const CaseHalves = lazy(() => import("./pages/CaseHalves"));
const CaseTailors = lazy(() => import("./pages/CaseTailors"));
const CaseIsrael = lazy(() => import("./pages/CaseIsrael"));
const CaseThelevels = lazy(() => import("./pages/CaseThelevels"));
const CaseSortMyTrash = lazy(() => import("./pages/CaseSortMyTrash"));
const CaseWizly = lazy(() => import("./pages/CaseWizly"));
const CaseRateMyLook = lazy(() => import("./pages/CaseRateMyLook"));

const Privacy = lazy(() => import("./pages/Privacy"));
const DebertsPrivacy = lazy(() => import("./pages/DebertsPrivacy"));
const AquaPalPrivacy = lazy(() => import("./pages/AquaPalPrivacy"));
const Page404 = lazy(() => import("./pages/404"));

const AdminPanelHome = lazy(
  () => import("./pages/AdminPanel/AdminPanelHome/AdminPanelHome"),
);
const AdminPanelLogin = lazy(
  () => import("./pages/AdminPanel/AdminPanelLogin/AdminPanelLogin"),
);
const AdminPanelPasswordRecovery = lazy(
  () =>
    import("./pages/AdminPanel/AdminPanelPasswordRecovery/AdminPanelPasswordRecovery"),
);
const AdminPanelNewPassword = lazy(
  () =>
    import("./pages/AdminPanel/AdminPanelNewPassword/AdminPanelNewPassword"),
);
const AdminPanelVacancies = lazy(
  () => import("./pages/AdminPanel/AdminPanelVacancies/AdminPanelVacancies"),
);
const AdminPanelVacancy = lazy(
  () => import("./pages/AdminPanel/AdminPanelVacancy/AdminPanelVacancy"),
);
const AdminPanelArticles = lazy(
  () => import("./pages/AdminPanel/AdminPanelArticles/AdminPanelArticles"),
);
const AdminPanelArticle = lazy(
  () => import("./pages/AdminPanel/AdminPanelArticle/AdminPanelArticle"),
);
const AdminPanelUsers = lazy(
  () => import("./pages/AdminPanel/AdminPanelUsers/AdminPanelUsers"),
);

const App = () => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(true);
      sessionStorage.setItem("preloader", "off");
    }, 3500);
  }, []);

  return (
    <>
      <div className="grid_wrapper">
        <Router>
          <Suspense fallback={<div></div>}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/company" element={<Company />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/ddt/" element={<ServiceDDT />} />
              <Route path="/services/outstaff" element={<ServiceOutstaff />} />
              <Route
                path="/services/outsource"
                element={<ServiceOutsource />}
              />
              <Route path="/cases" element={<Cases />} />
              <Route path="/cases/joinuz" element={<CaseJoinuz />} />
              <Route path="/cases/halves" element={<CaseHalves />} />
              <Route path="/cases/ziksen" element={<CaseZiksen />} />
              <Route path="/cases/startup-show" element={<CaseStartup />} />
              <Route path="/cases/israel-tv" element={<CaseIsrael />} />
              <Route path="/cases/rainbow" element={<CaseRainbow />} />
              <Route path="/cases/saqure" element={<CaseSaqure />} />
              <Route path="/cases/tailors" element={<CaseTailors />} />
              <Route path="/cases/aqua-pal" element={<CaseAquaPal />} />
              <Route path="/cases/joyn" element={<CaseJoyn />} />
              <Route path="/cases/zise" element={<CaseZise />} />
              <Route path="/cases/thelevels" element={<CaseThelevels />} />
              <Route
                path="/cases/sort-my-trash"
                element={<CaseSortMyTrash />}
              />
              <Route path="/cases/how-i-look" element={<CaseRateMyLook />} />
              <Route path="/cases/wizly" element={<CaseWizly />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route
                path="/deberts_note/privacy_policy.html"
                element={<DebertsPrivacy />}
              />
              <Route
                path="/cases/aqua-pal/privacy-policy"
                element={<AquaPalPrivacy />}
              />

              <Route
                path="/admin-panel/"
                element={
                  <CheckAuth>
                    <AdminPanelHome />
                  </CheckAuth>
                }
              />
              <Route path="/admin-panel/login" element={<AdminPanelLogin />} />
              <Route
                path="/admin-panel/password-recovery"
                element={<AdminPanelPasswordRecovery />}
              />
              <Route
                path="/admin-panel/new-password/:id/:linkJwt"
                element={<AdminPanelNewPassword />}
              />

              <Route
                path="/admin-panel/vacancies"
                element={
                  <CheckAuth>
                    <CheckRoles
                      roles={["ADMIN", "HR", "COPYWRITER + HR", "OWNER"]}
                    >
                      <AdminPanelVacancies />
                    </CheckRoles>
                  </CheckAuth>
                }
              />
              <Route
                path="/admin-panel/vacancy"
                element={
                  <CheckAuth>
                    <CheckRoles
                      roles={["ADMIN", "HR", "COPYWRITER + HR", "OWNER"]}
                    >
                      <AdminPanelVacancy />
                    </CheckRoles>
                  </CheckAuth>
                }
              />
              <Route
                path="/admin-panel/vacancy/:id/edit"
                element={
                  <CheckAuth>
                    <CheckRoles
                      roles={["ADMIN", "HR", "COPYWRITER + HR", "OWNER"]}
                    >
                      <AdminPanelVacancy />
                    </CheckRoles>
                  </CheckAuth>
                }
              />

              <Route
                path="/admin-panel/articles"
                element={
                  <CheckAuth>
                    <CheckRoles
                      roles={[
                        "ADMIN",
                        "COPYWRITER",
                        "COPYWRITER + HR",
                        "OWNER",
                      ]}
                    >
                      <AdminPanelArticles />
                    </CheckRoles>
                  </CheckAuth>
                }
              />

              <Route
                path="/admin-panel/article"
                element={
                  <CheckAuth>
                    <CheckRoles
                      roles={[
                        "ADMIN",
                        "COPYWRITER",
                        "COPYWRITER + HR",
                        "OWNER",
                      ]}
                    >
                      <AdminPanelArticle />
                    </CheckRoles>
                  </CheckAuth>
                }
              />

              <Route
                path="/admin-panel/article/:articleURL/edit"
                element={
                  <CheckAuth>
                    <CheckRoles
                      roles={[
                        "ADMIN",
                        "COPYWRITER",
                        "COPYWRITER + HR",
                        "OWNER",
                      ]}
                    >
                      <AdminPanelArticle />
                    </CheckRoles>
                  </CheckAuth>
                }
              />

              <Route
                path="/admin-panel/users"
                element={
                  <CheckAuth>
                    <CheckRoles roles={["ADMIN", "OWNER"]}>
                      <AdminPanelUsers />
                    </CheckRoles>
                  </CheckAuth>
                }
              />

              <Route path="*" element={<Page404 />} />
            </Routes>

            {sessionStorage.getItem("preloader") == "off" ||
            isLoading ? null : (
              <Preloader />
            )}
            <Cookies />
            <ToastContainer />
          </Suspense>
        </Router>
      </div>
    </>
  );
};

export default App;
